import React from 'react';
import { styled } from '@linaria/react';

import { Session } from '@blocks/types/session';

import { USER_ROLE_OPERATOR } from '../../constants';

const DisabledContainer = styled.div`
  width: 100%;
  max-width: 356px;
`;

const DisabledTitle = styled.div`
  font-size: 26px;
  font-weight: 700;
  line-height: 32px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #dae6f2;
  padding-bottom: 24px;
  margin-bottom: 24px;
  color: #424242;
`;

const DisabledText = styled.p`
  font-size: 22px;
  font-weight: 400;
  line-height: 32px;
  padding-bottom: 32px;
  color: #424242;
  margin: 0;
`;

const DisabledLogout = styled.button`
  outline: none;
  padding: 0;
  margin: 0;
  background: transparent;
  border: none;
  font-family: inherit;
  font-size: inherit;
  color: var(--bb-link-color);
  display: inline;

  &:hover {
    cursor: pointer;
    color: var(--bb-link-color--hover);
    text-decoration: underline;
  }
`;

const OrderDisabled: React.FC<{
  user_role: Session['user_role'] | undefined;
  logoutHandler: () => void;
}> = ({ user_role, logoutHandler }) => {
  const article = user_role === USER_ROLE_OPERATOR ? 'an' : 'a';

  return (
    <DisabledContainer>
      <DisabledTitle>
        You are currently logged in as {article} {user_role}
      </DisabledTitle>

      <DisabledText>
        Only <b>customers</b> can place orders in the system.
      </DisabledText>
      <DisabledText>
        Please{' '}
        <DisabledLogout
          type="button"
          onClick={logoutHandler}
        >
          log out
        </DisabledLogout>{' '}
        if you would like to place an order.
      </DisabledText>
    </DisabledContainer>
  );
};

export default OrderDisabled;
